<template>
<Dialog
    :visible.sync="showDialog"
    :width="`${vm.width || 428}px`"
    title="访问验证"
    okText="提交"
    :onOk="sendCapcha"
    cancelText="取消"
>
    <div :class="bem('modal-tip')">
        亲，这是个机器猖狂的时代，请输入验证码证明咱是正常人！
    </div>
    <Input v-model="capcha" placeholder="按下图中的字符填写，不区分大小写"/>
    <div :class="bem('code-img')" v-html="codeSvg"/>
    <Button :class="bem('code-change')" type="text" @click="getCapcha">看不清楚？换一个</Button>
</Dialog>

</template>
<script>
import _Dialog from "@gaoding/gdui/lib/dialog";
import _Button from "@gaoding/gdui/lib/button";
import _Input from "@gaoding/gdui/lib/input";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import bemMixin from '../bem';
export default {
  name: 'capcha-dailog',
  components: {
    Input: _Input,
    Button: _Button,
    Dialog: _Dialog
  },
  mixins: [bemMixin],
  props: {
    // 提交图形验证码需要和发送验证码一样的type
    type: {
      type: String,
      default: ''
    },
    isUnSendCode: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showDialog: false,
      capcha: '',
      codeSvg: ''
    };
  },
  inject: ['vm'],
  methods: {
    // 显示弹窗
    show: function show() {
      this.showDialog = true;
      this.getCapcha();
    },
    // 提交图形验证码
    sendCapcha: function sendCapcha() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.capcha) {
                  _context.next = 3;
                  break;
                }

                _this.vm.$emit('error', {
                  error: new Error('请输入图形验证码'),
                  action: 'verifyCode',
                  type: 'verifyCode'
                });

                return _context.abrupt("return", false);

              case 3:
                if (!_this.isUnSendCode) {
                  _context.next = 7;
                  break;
                }

                _this.$emit('onOk', _this.capcha);

                _this.showDialog = false;
                return _context.abrupt("return");

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return _this.vm.requestUms('sendVerifyCode', _objectSpread(_objectSpread({}, _this.vm.form), {}, {
                  capcha: _this.capcha,
                  type: _this.type
                }));

              case 10:
                _this.showDialog = false;

                _this.$emit('onOk', _this.capcha);

                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);

                _this.vm.$emit('error', {
                  error: _context.t0,
                  action: 'verifyCode',
                  type: 'verifyCode'
                });

                return _context.abrupt("return", false);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 14]]);
      }))();
    },
    // 获取图形验证码
    getCapcha: function getCapcha() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.capcha = '';
                _context2.next = 3;
                return _this2.vm.requestUms('getCapcha', _objectSpread({}, _this2.vm.form));

              case 3:
                data = _context2.sent;
                _this2.codeSvg = data;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};
</script>
<style>
.capcha-dailog__modal-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0 21px;
}
.capcha-dailog__modal-title :nth-child(1) {
  font-size: 16px;
  font-weight: bold;
  font-family: SFProText-Bold;
  color: #000;
}
.capcha-dailog__close {
  cursor: pointer;
  opacity: 0.6;
  font-size: 20px;
  color: #AAA;
}
.capcha-dailog__close:hover {
  opacity: 1;
}
.capcha-dailog__code-change {
  padding: 2px 0;
  color: #005CF9;
}
.capcha-dailog__modal-tip {
  margin: 4px 0 16px;
  color: #000;
  font-weight: 400;
  font-family: PingFangSC-Regular;
}
.capcha-dailog__code-img {
  width: 128px;
  height: 64px;
  margin: 10px 0 7px;
}
.capcha-dailog__code-img > svg {
  width: 100%;
  height: 100%;
}
.capcha-dailog__modal-confirm {
  display: flex;
  justify-content: flex-end;
  height: 64px;
  margin-top: 48px;
}
.capcha-dailog__modal-confirm > button {
  width: 68px;
  padding: 0;
}
.capcha-dailog__modal-confirm :nth-child(2) {
  margin-left: 8px;
}

</style>
